export const LONG_NOTE_ACTIVITY_PATTERNS = [
  /\bparticipat(?:ed|ing)\b/i,
  /\bjoined\b/i,
  /\bworked\b/i,
  /\bworking with\b/i,
  /\bworking with the other kids\b/i,
  /\btherapy\b/i,
  /\bexercise\b/i,
  /\bart class\b/i,
  /\bgroup painting activity\b/i,
  /\bgroup painting\b/i,
  /\bteacher mentioned\b/i,
  /\bschool pickup\b/i,
  /\brecess\b/i,
  /\bswings?\b/i,
  /\bplayed independently\b/i,
  /\bshow(?:ed)? her artwork\b/i,
  /\benjoyed\b/i,
  /\bfollowed directions\b/i,
  /\bengaged\b/i,
  /\btolerat(?:ed|ing)\b/i,
  /\bimprov(?:ed|ement)\b/i,
  /\bgroup work\b/i,
  /\bproject\b/i,
  /\bfocused\b/i,
  /\bindependent(?:ly)?\b/i,
];

export const LONG_NOTE_BEHAVIOR_DOMINANT_PATTERNS = [
  /\b(?:behavior[- ]wise|behavior incident|incident|escalat(?:ed|ion)|frustrat(?:ed|ing)|upset|yell(?:ed|ing)?|scream(?:ed|ing)?|push(?:ed|ing)?|hit(?:ting)?|kick(?:ed|ing)?|bite(?:n|ing)?|throw(?:ing|n)?|aggress(?:ion|ive)?|redirect(?:ed|ion)?|calm corner|sensory squeezes?|deep breathing|covered (?:his|her|their) ears|raised (?:his|her|their) voice|bumped into him|bumped into her|bumped into them)\b/i,
];

export const LONG_NOTE_ACTIVITY_DOMINANT_PATTERNS = [
  /\b(?:participat(?:ed|ing)|joined|worked|working with|music therapy|art class|group painting activity|group painting|teacher mentioned|school pickup|recess|swings?|played independently|show(?:ed)? her artwork|followed directions|engaged|reading time|drum activity)\b/i,
];

export const LONG_NOTE_FOOD_PRIMARY_PATTERNS = [
  /\b(?:ate|drank|eating|drinking|had|finished|refused|did not eat|didn't eat|would not eat|wouldn't eat|only ate|few bites|most of the|a few bites|snack|breakfast|lunch|dinner|meal|juice|water bottle)\b/i,
];

export const LONG_NOTE_FOOD_CONSUMPTION_PATTERNS = [
  /\b(?:ate|drank|eating|drinking|had|finished|refused|did not eat|didn't eat|would not eat|wouldn't eat|only ate|few bites|most of the|a few bites)\b/i,
];

export const LONG_NOTE_FOOD_CONTEXT_PATTERNS = [
  /\b(?:breakfast|lunch|dinner|snack|meal)\b/i,
  /\b(?:yogurt|rice|chicken|cucumber|bagel|cream cheese|eggs|strawberries|juice|crackers|chips|apple|pasta|water bottle|milk)\b/i,
];

export const LONG_NOTE_MEDICATION_SIDE_EFFECT_PATTERNS = [
  /\b(?:side effects?|appetite|reduced appetite|no appetite|less appetite|more appetite|nausea|sleepy|drowsy|calmer|calmed|better regulated|tolerated well|no concerns|no issues|no problems)\b/i,
];

export const LONG_NOTE_MOOD_PATTERNS = [
  /\b(?:happy|affectionate|tired|anxious|worried|excited|calm|calmer|frustrated|upset|sad|content|nervous|laugh(?:ed|ing)?|smiled|giggl(?:ed|ing))\b/i,
];

export const LONG_NOTE_MILESTONE_DOMINANT_PATTERNS = [
  /\b(?:progress|improv(?:ed|ement)|success(?:ful)?|independent(?:ly)?|proud|accomplishment|great job|did well|better than|nice improvement)\b/i,
];

export const LONG_NOTE_SLEEP_PATTERNS = [
  /\b(?:sleep|slept|asleep|fall asleep|fell asleep|nap|napped|woke up|woke|bedtime|rest time)\b/i,
];

export const LONG_NOTE_SLEEP_WITH_ROUGH_NIGHT_PATTERNS = [
  /\b(?:rough night|sleep|slept|asleep|fall asleep|fell asleep|nap|napped|woke up|woke|bedtime|rest time)\b/i,
];
